import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { headingStyles } from '@helpers/typography';
import { m } from 'framer-motion';
import styled from 'styled-components';
const DesktopContainer = styled.nav `
  padding-top: 4px;

  @media ${until(Device.TabletLarge)} {
    display: none;
  }
`;
const MobileContainer = styled.nav `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 100;
  background-color: ${brand.black};
  padding: 40px 20px 60px;
  pointer-events: none;
  visibility: hidden;
  opacity: 0;
  ${transition('visibility, opacity')};

  // dynamic viewport height. Means the height will change with scroll to account for address bars.
  @supports (height: 100dvh) {
    height: 100dvh;
  }

  &[data-menu-open='true'] {
    opacity: 1;
    visibility: visible;
    pointer-events: all;

    @media ${from(Device.TabletLarge)} {
      display: none;
    }
  }

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const CloseBtn = styled.button `
  position: absolute;
  bottom: 30px;
  right: 15px;
  z-index: 1;
  width: 35px;
  height: 35px;
  padding: 9px;
  border: 1px solid ${brand.primary.beige};
  border-radius: 100%;
  background: transparent;
  color: ${brand.primary.beige};
  ${transition('background-color, color')};

  &:hover {
    color: ${brand.black};
    background-color: ${brand.primary.beige};
  }
`;
const Inner = styled.div `
  display: flex;
  align-items: center;
  gap: ${fluid(16, 32)};

  @media ${until(Device.TabletLarge)} {
    flex-direction: column;
    overflow: auto;
    transform: translateY(10px);
    opacity: 0;
    ${transition('opacity, transform')};
    transition-delay: 0.35s;
    align-items: normal;

    ${MobileContainer}[data-menu-open='true'] & {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;
const NavItem = styled.div `
  position: relative;
`;
const NavItemVenture = styled(NavItem) `

`;
const NavLink = styled.a `
  ${headingStyles};
  position: relative;
  font-size: 14px;
  margin-bottom: 0;
  text-decoration: none;
  display: block;

  @media ${until(Device.TabletLarge)} {
    padding: 10px 0;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 3.6px;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: ${brand.primary.beige};
    ${transition('transform', 0.4, 'cubic-bezier(0.45, 0.05, 0.5, 0.1)')}
    transform-origin: 0 0;
    transform: scaleX(0);

    @media ${until(Device.TabletLarge)} {
      display: none;
    }
  }

  &:hover,
  &:active {
    text-decoration: none;

    &::after {
      transform: scaleX(1);
    }
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-color: ${brand.white};
  }
`;
const FakeNavLink = styled.div `
  ${headingStyles};
  font-size: 14px;
  margin-bottom: 0;
  cursor: default;
`;
const DropDown = styled.div `
  ${transition('opacity, max-height')};
  position: absolute;
  top: calc(100% + 2px);
  left: -20px;
  z-index: 1;
  width: 250px;
  background-color: ${brand.black};
  opacity: 0;
  max-height: 0;
  overflow: hidden;

  ${NavItem}:hover &,
  &:focus-within {
    max-height: 700px;
    opacity: 1;
  }
`;
const DropDownInner = styled.div `
  padding: 50px 20px 20px;
  display: flex;
  flex-direction: column;

  @media ${until(Device.TabletLarge)} {
    padding: 10px 20px;
  }
`;
const DropDownItem = styled.div `
  padding-bottom: 20px;

  @media ${until(Device.TabletLarge)} {
    padding-bottom: 0;

    ${NavLink} {
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 2.8px;
    }
  }

  &:last-child {
    padding-bottom: 0;
  }

  ${NavLink} {
    display: inline-block;
  }
`;
const ParentButton = styled.button `
  ${headingStyles};
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 3.6px;
  margin-bottom: 0;
  padding: 10px 0;
  text-align: left;
  background: transparent;
  border: none;
  width: 100%;
  position: relative;
  color: ${brand.white};

  &[data-dropdown-open='true'] {
    svg {
      transform: rotate(-90deg);
    }
  }

  svg {
    position: absolute;
    right: 3px;
    top: 13px;
    height: 12px;
    color: ${brand.primary.beige};
    transform: rotate(90deg);
  }
`;
const MobileDropDown = styled(m.div) `
  overflow: hidden;
`;
const Image = styled.img `
  ${transition('transform')};

  ${NavItemVenture}:hover & {
    @media ${from(Device.TabletLarge)} {
      transform: translateY(-5px);
    }
  }
`;
const NavigationStyles = {
    CloseBtn,
    DesktopContainer,
    DropDown,
    DropDownInner,
    DropDownItem,
    FakeNavLink,
    Image,
    Inner,
    MobileContainer,
    MobileDropDown,
    NavItem,
    NavItemVenture,
    NavLink,
    ParentButton,
};
export default NavigationStyles;
